import { useState } from "react";
import { Image } from "./image";
import { Tabs, TabItem } from "./tabs.jsx";

export const Gallery = (props) => {
  const [visible, setVisible] = useState(3);

  const caseStudies = props.data;
  const length = caseStudies?.length;

  const devCaseStudies =
    caseStudies && caseStudies.filter((el) => el.type !== "devops");
  const devopsCaseStudies =
    caseStudies && caseStudies.filter((el) => el.type !== "development");

  const showMore = () => {
    setVisible(length);
  };

  const categoryCaseStudy = (category) => {
    return category.slice(0, visible).map((d, i) => (
      <div
        key={`${d.title}-${i}`}
        className="col-sm-6 col-md-4 col-lg-4 fade-in"
      >
        <Image
          title={d.title}
          largeImage={d.largeImage}
          smallImage={d.smallImage}
        />
      </div>
    ));
  };

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our portfolio</h2>
          <p></p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {caseStudies ? categoryCaseStudy(caseStudies) : "Loading..."}            
            
            {visible < length && (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <button
                onClick={showMore}
                className="btn btn-custom mt-30 btn-lg"
              >
                Show more
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
